import React, { useState, useEffect } from 'react';
import { Typography as MuiTypography, Grid, Typography, useMediaQuery, useTheme, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
  CarouselProvider,
  Image,
  Slide,
  Slider,
  ButtonBack,
  ButtonNext,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import clsx from 'clsx';
import { toast } from 'react-toastify';
import { useStyles } from './styles';
import { LibraryData } from 'services/dataService';
import {
  ArrowBackIos, ArrowForwardIos
} from '@material-ui/icons';
import { useSelector } from 'react-redux';

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}

export default ({ className, listDataChangeObservable, ...rest }) => {
  const [loading, setLoading] = useState(true);
  const [visibleSlides, setVisibleSlides] = useState(0);
  const theme = useTheme();

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });
  const size = useWindowSize();
  const [downloadLinks, setDownloadLinks] = useState([]);
  const { id: user_id } = useSelector((state) => state.auth);
  const { company } = useSelector((state) => state);

  const { t } = useTranslation([
    'title',
    'label',
    'form',
    'button',
    'toastify',
  ]);

  const fetchData = async () => {
    try {
      const responseLib = await LibraryData.getLibrarytop10({
        limit: 10,
        iduser: user_id,
      });

      setDownloadLinks(responseLib.data.library);

    } catch (err) {
      if (err.response?.status === 403) {
        toast.error(t('toastify:commons.toast_error_403'));
      } else {
        toast.error(t('toastify:commons.toast_error_api'));
      }
    }
  };
  const handleDownload = async (rowData) => {
    try {

      toast.info(t('toastify:commons.toast_start_download_library'));

      const formValues = {
        fileName: rowData.urlfile,
        fileType: rowData.file_type,
        iduser: user_id,
        idlibrary: rowData.id,
      };

      const signedurls3 = await LibraryData.signs3geturlstudent(formValues)

      const response = await fetch(signedurls3.data.signedUrl);
      const blob = await response.blob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = rowData.nameorigem;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error downloading file', error);
      toast.error(t('toastify:commons.toast_error_download_library'));
    }
  };

  useEffect(() => {
    fetchData();
    setLoading(false);

  }, []);

  useEffect(() => {
    isDesktop
      ? setVisibleSlides(Math.trunc((size.width - 336) / 200))
      : setVisibleSlides(Math.trunc(size.width / 200));
  }, [size]);


  const classes = useStyles();

  return (
    <>
      {!loading && (
        <div {...rest} className={[clsx(classes.root, className, 'notranslate')]}>
          <Grid container className={classes.quickAccessContainer}>
            <Grid item md={4} xs={12}>
              <MuiTypography
                variant="h4"
                className={downloadLinks.length === 1 ? classes.hidden : {}}
              >
                {t('label:librarystud.label_access_quick')}:
              </MuiTypography>
            </Grid>
            <Grid item md={8} xs={12} >
            </Grid>
          </Grid>

          <Grid
            className={clsx(
              classes.rowStatus,
              downloadLinks.length === 1 && classes.hidden
            )}
          >
            <CarouselProvider
              visibleSlides={visibleSlides}
              totalSlides={downloadLinks.length}
              naturalSlideWidth={50}
              naturalSlideHeight={50}
              className={classes.carrossel}
            >
              <ButtonBack className={classes.buttons} style={{ left: -15 }}>
                <ArrowBackIos />
              </ButtonBack>

              <ButtonNext className={classes.buttons} style={{ right: -15 }}>
                <ArrowForwardIos />
              </ButtonNext>
              <Slider tabIndex={-1} className={classes.slideContainer}>
                {downloadLinks
                  .sort((a, b) => (a.index > b.index ? 1 : -1))
                  .map((link, i) => (
                    <Slide key={link.id || i} tabIndex={-1} index={i}>
                      <Box onClick={() => handleDownload(link)} className={classes.slideCard}>
                        <Image
                          className={classes.imageCompany}
                          src={link?.url_thumbnail || company?.theme?.logo?.url}
                          style={{
                            objectFit: link?.url_thumbnail ? 'cover' : 'contain',
                          }}
                        />
                        <Typography className={classes.text}>
                          {link.title}
                        </Typography>
                      </Box>
                    </Slide>
                  ))}
              </Slider>
            </CarouselProvider>
          </Grid>
        </div>
      )}
    </>
  );
};
